"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuSecondaryText = exports.MenuMetadata = exports.MenuHotkeyHint = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _MenuItemSecondaryTextStyled = require("../styled/MenuItemSecondaryTextStyled");
// We still want the namespace
// eslint-disable-next-line @typescript-eslint/no-empty-interface

const MenuMetadata = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_MenuItemSecondaryTextStyled.MenuItemSecondaryTextStyled, {
    ref: ref,
    themeKey: themeMode,
    variant: "metadata"
  }, children);
});
exports.MenuMetadata = MenuMetadata;
MenuMetadata.displayName = "MenuMetadata";
const MenuHotkeyHint = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
  let {
    children,
    clientId
  } = _ref2;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_MenuItemSecondaryTextStyled.MenuItemSecondaryTextStyled, {
    ref: ref,
    themeKey: themeMode,
    variant: "hint",
    "data-client-id": clientId
  }, children);
});
exports.MenuHotkeyHint = MenuHotkeyHint;
MenuHotkeyHint.displayName = "MenuHotkeyHint";

// Same styles, but alias them for more semantic usage & backward compatibility
const MenuSecondaryText = MenuMetadata;
exports.MenuSecondaryText = MenuSecondaryText;
MenuSecondaryText.displayName = "MenuSecondaryText";
//# sourceMappingURL=MenuItemSecondaryText.js.map